import { AutoMap } from '@automapper/classes';

export class ProcessMeasureEntity {
    Id?: number;
    @AutoMap()
    Code!: string;
    @AutoMap()
    IsCancelled!: boolean;
    @AutoMap()
    MeasureReferenceCode!: string;
    @AutoMap()
    MeasureReferenceName!: string;
    @AutoMap()
    Status!: number;
    @AutoMap()
    Localisation!: string;
    @AutoMap()
    TextColor!: string;
    @AutoMap()
    Color!: string;
    // @AutoMap()
    // SamplingID : int 
    @AutoMap()
    Observation?: string;
    ProcessSamplingConditionId?: number;

    OperatorIds?: number[];
    SecuriteId?: number;
}
